(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('booster-hero-slideshow')) {
    customElements.define('booster-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-hero-track]');
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        if (!this.track || !this.slides.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.index = 0;
        this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.playing = this.dataset.autoplay === 'true' && !this.motion.matches && this.dataset.editor !== 'true';
        this.visible = true;
        this.hovered = false;
        this.dragging = false;
        this.toggle = this.querySelector('[data-hero-toggle]');
        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1), {signal});
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1), {signal});
        this.toggle?.addEventListener('click', () => {
          this.playing = !this.playing;
          this.hovered = false;
          this.update();
          this.schedule();
        }, {signal});
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
            this.update();
            this.schedule();
          }, 150);
        }, {passive: true, signal});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.go(next);
        }, {signal});
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, {signal});
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
        this.track.addEventListener('pointerdown', () => { this.dragging = true; this.schedule(); }, {signal});
        window.addEventListener('pointerup', () => { this.dragging = false; this.schedule(); }, {signal});
        window.addEventListener('pointercancel', () => { this.dragging = false; this.schedule(); }, {signal});
        this.addEventListener('focusin', event => {
          // The rotation control must remain operable without reversing its own action.
          if (event.target === this.toggle) return;
          this.playing = false;
          this.update();
          this.schedule();
        }, {signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.playing = false;
          this.update();
          this.schedule();
        }, {signal});
        this.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (selected < 0) return;
          this.playing = false;
          this.go(selected, false);
        }, {signal});
        this.resizeObserver = new ResizeObserver(() => {
          const header = document.querySelector('[data-header]');
          if (header) this.style.setProperty('--hero-header-height', header.getBoundingClientRect().height + 'px');
          this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: 'instant'});
        });
        this.resizeObserver.observe(this.track);
        const header = document.querySelector('[data-header]');
        if (header) this.resizeObserver.observe(header);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, {threshold: 0.15});
        this.intersectionObserver.observe(this);
        this.classList.add('is-ready');
        this.update();
        this.schedule();
      }
      update() {
        this.slides.forEach((slide, i) => {
          slide.inert = i !== this.index;
          slide.setAttribute('aria-hidden', String(i !== this.index));
        });
        const counter = this.querySelector('[data-hero-current]');
        if (counter) counter.textContent = String(this.index + 1);
        this.track.setAttribute('aria-live', this.playing ? 'off' : 'polite');
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-label', this.playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
        this.querySelector('[data-hero-pause-icon]').hidden = !this.playing;
        this.querySelector('[data-hero-play-icon]').hidden = this.playing;
      }
      go(next, animate = true) {
        const wrapped = next < 0 || next >= this.slides.length;
        this.index = (next + this.slides.length) % this.slides.length;
        this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: animate && !wrapped && !this.motion.matches ? 'smooth' : 'instant'});
        this.update();
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.playing || !this.visible || this.hovered || this.dragging || document.hidden || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('booster-random-recommendations')) {
    customElements.define('booster-random-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.showProducts(), { once: true });
        } else {
          this.showProducts();
        }
      }
      showProducts() {
        if (this.dataset.ready === 'true' || !this.isConnected) return;
        const pool = this.querySelector('[data-recommendation-pool]');
        const grid = this.querySelector('[data-recommendation-grid]');
        if (!pool || !grid) return;
        const seen = new Set([this.dataset.productId]);
        const cards = Array.from(pool.content.querySelectorAll('[data-recommendation-id]')).filter(card => {
          const id = card.dataset.recommendationId;
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        });
        // Shuffle the candidate pool, then take four distinct products on each page load.
        for (let i = cards.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [cards[i], cards[j]] = [cards[j], cards[i]];
        }
        grid.replaceChildren(...cards.slice(0, 4).map(card => card.cloneNode(true)));
        this.hidden = cards.length === 0;
        this.dataset.ready = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
